import React from 'react';
import '../../assets/styles/Home.css';

/* Tarjeta de reconocimiento de la landing. Se usa en la home (se despliega al
   pasar por encima o al pulsar) y en el panel de sellos, donde va siempre
   abierta y sin boton porque solo es una vista previa. */

const Medal = () => (
  <svg className="rank__medal" viewBox="0 0 1024 1024" width="72" height="72" aria-hidden="true">
    <path d="M896 42.666667h-128l-170.666667 213.333333h128z" fill="#C026D3" />
    <path d="M768 42.666667h-128l-170.666667 213.333333h128z" fill="#2563EB" />
    <path d="M640 42.666667h-128L341.333333 256h128z" fill="#F1F1F1" />
    <path d="M128 42.666667h128l170.666667 213.333333H298.666667z" fill="#C026D3" />
    <path d="M256 42.666667h128l170.666667 213.333333h-128z" fill="#2563EB" />
    <path d="M384 42.666667h128l170.666667 213.333333h-128z" fill="#FBFBFB" />
    <path d="M298.666667 256h426.666666v213.333333H298.666667z" fill="#6D28D9" />
    <path d="M512 661.333333m-320 0a320 320 0 1 0 640 0 320 320 0 1 0-640 0Z" fill="#A78BFA" />
    <path d="M512 661.333333m-256 0a256 256 0 1 0 512 0 256 256 0 1 0-512 0Z" fill="#6D28D9" />
    <path
      d="M512 661.333333m-213.333333 0a213.333333 213.333333 0 1 0 426.666666 0 213.333333 213.333333 0 1 0-426.666666 0Z"
      fill="#8B5CF6"
    />
    <path
      d="M277.333333 256h469.333334a21.333333 21.333333 0 0 1 0 42.666667h-469.333334a21.333333 21.333333 0 0 1 0-42.666667z"
      fill="#5B21B6"
    />
    <path
      d="M512 746.666667l-100.309333 52.736 19.157333-111.701334-81.152-79.104 112.128-16.298666L512 490.666667l50.176 101.632 112.128 16.298666-81.152 79.104 19.157333 111.701334z"
      fill="#EDE9FE"
    />
  </svg>
);

const Chevron = () => (
  <svg className="rank__chevron" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
    <path
      d="M6 9l6 6 6-6"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SealCard = ({ seal, open = false, onToggle, detailId, className = '' }) => {
  const isOpen = onToggle ? open : true;
  const name = [seal.title_top, seal.title_bottom].filter(Boolean).join(' ');

  const front = (
    <>
      <span className="rank__top">
        <span className="rank__tag">{seal.kicker}</span>
        <span className="rank__badge">
          <Medal />
        </span>
      </span>

      <span className="rank__name">{name}</span>

      <span className="rank__foot">
        <span className="rank__rule" aria-hidden="true"></span>
        <Chevron />
      </span>
    </>
  );

  return (
    <article className={`rank ${isOpen ? 'is-open' : ''} ${className}`.replace(/\s+/g, ' ').trim()}>
      {onToggle ? (
        <button
          type="button"
          className="rank__front"
          aria-expanded={open}
          aria-controls={detailId}
          onClick={onToggle}
        >
          {front}
        </button>
      ) : (
        <div className="rank__front">{front}</div>
      )}

      <div className="rank__detail" id={detailId}>
        <div className="rank__detail-text">
          {seal.level && <p className="rank__value">{seal.level}</p>}
          {seal.caption && <p className="rank__caption">{seal.caption}</p>}
        </div>
      </div>
    </article>
  );
};

export default SealCard;
